import { render, staticRenderFns } from "./qxtbxiangqing.vue?vue&type=template&id=dfe8164c&scoped=true"
import script from "./qxtbxiangqing.vue?vue&type=script&lang=js"
export * from "./qxtbxiangqing.vue?vue&type=script&lang=js"
import style0 from "./qxtbxiangqing.vue?vue&type=style&index=0&id=dfe8164c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe8164c",
  null
  
)

export default component.exports